import React from "react"
import CustomInput from "../components/CustomInput";

export default function ShortAnswer({name, changeWriteAnswer, data, isPassed, userAnswers}) {
  let right = 'rgba(253, 128, 128, 0.76)';
  if(isPassed) {
    data.forEach(item => {
    if(item.name === userAnswers.value) {
      right = 'rgba(128, 253, 195, 0.76)';
    }
  })
  }
  
  const styles = {
    backgroundColor: right,
  }

  return (
    <>
      <label className="test-check-text">Ваш ответ:</label>
      {/*<input className="test-answer-general" style={isPassed ? styles : null} type="text" name={`a${name}`} onChange={(e) => changeWriteAnswer(e)} disabled={isPassed}/>*/}
      <CustomInput className="test-answer-general" style={isPassed ? styles : null} type="text" onChange={changeWriteAnswer} disabled={isPassed}/>
    </>
  )
}